/* ===== Miaw Vibes — theme.js =====
   Original animations preserved 1:1 + small Shopify-safe additions.
   faq(), openMob(), closeMob() are global so inline onclick handlers keep working. */

// Scroll reveal (re-usable so it also works after Theme Editor re-renders a section)
function initReveal(root){
  var scope = root || document;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('in'); } });
  }, { threshold:.1, rootMargin:'0px 0px -50px 0px' });
  scope.querySelectorAll('.rv:not(.in),.rl:not(.in),.rr:not(.in)').forEach(function(el){ io.observe(el); });
}
document.addEventListener('DOMContentLoaded', function(){ initReveal(document); });
initReveal(document);

// FAQ accordion (single open)
function faq(el){
  var it = el.parentElement,
      o = it.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach(function(f){ f.classList.remove('open'); });
  if(!o) it.classList.add('open');
}

// Quantity / bundle selector
function bindQty(){
  document.querySelectorAll('.qty-btn').forEach(function(b){
    b.addEventListener('click', function(){
      document.querySelectorAll('.qty-btn').forEach(function(x){ x.classList.remove('active'); });
      this.classList.add('active');
      var qty = this.getAttribute('data-qty') || '1';
      var input = document.getElementById('buyQty');
      if(input){ input.value = qty; }
      var direct = document.getElementById('buyDirect');
      if(direct && direct.dataset.base){ direct.href = direct.dataset.base + ':' + qty; }
    });
  });
}
document.addEventListener('DOMContentLoaded', bindQty);

// Mobile menu
function openMob(){ var m=document.getElementById('mobMenu'); if(m){ m.classList.add('open'); document.body.style.overflow='hidden'; } }
function closeMob(){ var m=document.getElementById('mobMenu'); if(m){ m.classList.remove('open'); document.body.style.overflow=''; } }

// Navbar shadow on scroll
window.addEventListener('scroll', function(){
  var nav = document.getElementById('navbar');
  if(nav){
    nav.style.boxShadow = window.scrollY>50
      ? '0 4px 30px rgba(247,37,133,.15)'
      : '0 2px 24px rgba(247,37,133,.07)';
  }
});

// Re-init reveal when Shopify Theme Editor loads/changes a section
document.addEventListener('shopify:section:load', function(e){ initReveal(e.target); bindQty(); });
